import type { FC } from 'react';
import { useGetIssueById } from 'src/hooks/queries';

type Props = {
  issueId: string | undefined;
};

const Breadcrumb: FC<Props> = ({ issueId }) => {
  const { data } = useGetIssueById(issueId!, !issueId);

  return <>{data?.issue?.[0]?.Title}</>;
};

export default Breadcrumb;
